import axios from "axios";

const instance = axios.create({
    //baseURL: 'https://localhost:9876',//DEV
    baseURL: 'https://new.geticketsonline.com:9876',//PROD
});

instance.interceptors.request.use(async(config) => {
    config.headers.ContentType = "application/json";
    return config;
});

export const getAll = async(param) =>
    await instance.post("event/all", { param });

export const singleMainEvent = async(mainEventId) =>
    await instance.post("event/single", { mainEventId });

export const mainEventCreate = async(eventInfo) =>
    await instance.post("event/create", { eventInfo });

export const mainEventUpdate = async(eventInfo) =>
    await instance.post("event/update", { eventInfo });

export const mainEventOrderUpdate = async(mainEventId,order) =>
    await instance.post("event/order/update", { mainEventId,order });

export const getAllDates = async(param, mainEventId) =>
    await instance.post("event/dates", { param, mainEventId });

export const eventDateCreate = async(eventInfo) =>
    await instance.post("event/date/create", { eventInfo });

export const eventDateUpdate = async(eventInfo) =>
    await instance.post("event/date/update", { eventInfo });

export const getAllTicketsByDate = async(date,mainEventId) =>
    await instance.post("event/tickets/date", { date,mainEventId });

export const getAllTickets = async(eventDateId,currency) =>
    await instance.post("event/tickets", { eventDateId,currency });

export const getTicketImage = async(eventDateId) =>
    await instance.post("event/ticket/image", { eventDateId });

export const getBottleMenu = async(currency) =>
    await instance.post("event/bottles/all",{currency});

export const getAllMedia = async() =>
    await instance.post("event/media/all");

export const deleteEventImage = async(image) =>
    await instance.post("event/media/delete",{image});

export const addEventImages = async(formData) =>
    await instance.post("event/media/add",formData);

export const getMainEventInfo = async(mainEventId) =>
    await instance.post("event/mainevent/info",{mainEventId});